import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/norrkoping")(
  heritageCityRoute({
    citySlug: "norrkoping",
    angle:
      "Norrköping bär en industrihistoria som fortfarande finns i människors minnen — och i regionens bolag finns erfarenhet som riskerar att försvinna vid nästa pensionsvåg.",
    localUseCases: [
      "Livsberättelse med koppling till industristaden",
      "Kunskapsöverföring inför pension i tillverkande bolag",
      "Företagshistoria och kulturdokumentation",
      "Släkthistoria kring textil- och industriarvet",
      "Generationsskifte i östgötska familjeföretag",
      "Minnesfilm till högtidsdag eller släktträff"
    ],
  }),
);
